// Import Required libaries
import React, { useMemo, useState } from "react";
import { Box, Card, Grid } from "@mui/material";
import { connect } from "react-redux";
import { masterTrackGaEvent } from "../../../services/ga";
import { useHistory } from "react-router-dom";
import { formatDistanceToNow, format } from "date-fns";
// Import Utils
import {
  initialWsFormScreenValue,
  wrapperUpdateWorksheetStatus,
  wrapperWs,
} from "../../../utils/analyzeUtils";
// Import Actions
import { initialActiveWorkspace } from "../../../redux/stateData";
import {
  updateUserScreen,
  updateDialogInfo,
  updateStandaloneWsForm,
} from "../../../redux/actions";
// Import Config
import { config } from "../../../config/config";
// Import Api's
import { deleteWorksheet, updateWorksheetStatus } from "../../../services/api";
// Import Common Components
import AnalyzeShareDialog from "../../Analyze/AnalyzeDashboard/AnalyzeShareDialog";
import SigviewTypography from "../../../components/Common/SigviewTypography";
import WorkspaceCreateHelpers from "./WorkspaceCreateHelpers";
// Import Assets/Images
import renameIcon from "../../../../assets/images/renameIcon.svg";
import deleteIcon from "../../../../assets/images/deleteIcon.svg";
import shareIcon from "../../../../assets/images/shareIcon.svg";
import NoSavedReport from "../../../../assets/images/NoSavedReport.svg";
import SigviewTooltip from "../../../components/Common/SigviewTooltip";

const WorkspaceGrid = (props) => {
  const {
    dispatch: ReduxDispatcher = () => {},
    user = {},
    standaloneWs: wsForm,
    allData = {},
    workbooks = {},
    searchQuery = "",
    setReloadWorkbooks,
  } = props;

  const history = useHistory();

  const handleWsFormChange = (key, value) => {
    const payload = { key, value };
    const action = updateStandaloneWsForm(payload);
    ReduxDispatcher(action);
  };

  const handleShowWorkbooksDrawer = (value) => {
    const newScreen = { ...initialWsFormScreenValue, allWorkbooks: value };
    handleWsFormChange("screen", newScreen);
  };
  const handleSnackbarMessageShow = (message) => {
    let snackbarPayload = {
      ...user.screen.snackbar,
      open: true,
      message: message,
    };
    const action = updateUserScreen("snackbar", snackbarPayload);
    ReduxDispatcher(action);
  };
  const handleWorkspaceOpen = (workbook, worksheet) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "Workspace",
      action: "OpenWorkspace",
      label: "Open",
    });

    // * ASYNC
    // 0. Redirect to /analyze/dashboard so that the shared URL is removed
    // 1. Close the drawer (Since AnalyzeDashboard will umount, it will anyways close; still putting it if in case logic changes later)
    // 2. Revert setIsAnyworkbookInRedux to unmound AnalyzeDashboard
    // 3. Set new active workspace in redux
    // 4. Reload Worksheet to trigger useEffect
    // 5. Trigger updateWorksheetStatus to update active worksheet in mongo

    // 0. Redirect to /analyze/dashboard so that the shared URL is removed
    history.push("/analyze/dashboard");

    // 1. Close the drawer (Since AnalyzeDashboard will umount, it will anyways close; still putting it if in case logic changes later)

    // Close the drawer
    handleShowWorkbooksDrawer(false);

    // 2. Revert setIsAnyworkbookInRedux to unmound AnalyzeDashboard

    // setIsAnyworkbookInRedux(false);

    // 3. Set new active workspace in redux

    // Set new active workspace in redux
    const activeWorkspacePayload = {
      workbook,
      worksheet,
    };
    const actionValue = {
      activeWorkspace: {
        wsCategory: "saved",
        crudType: "update",
        payload: activeWorkspacePayload,
      },
    };
    var action = updateUserScreen(null, actionValue);
    ReduxDispatcher(action);

    // 4. Reload Worksheet to trigger useEffect

    // setReloadWorksheet(Date.now());

    // 5. Trigger updateWorksheetStatus to update active worksheet in mongo
    const modWorksheet = { ...worksheet, isActive: true };
    const payload = wrapperUpdateWorksheetStatus({
      workbook,
      worksheet: modWorksheet,
    });
    const fetchProps = { payload };
    const updateWorksheetStatusPromise = updateWorksheetStatus(fetchProps);
    updateWorksheetStatusPromise
      .then((responseData) => {
        // Post success, reload the workbook data so that it has the correct active worksheet
        // setReloadWorkbooks(Date.now());
      })
      .catch((json) => {
        if (json.error !== config.hardCoded.queryCancelled) {
          console.groupCollapsed("UI ERROR");
          console.log("ERROR -> ", json.error);
          console.log("updateWorksheetStatus API failed");
          console.groupEnd();

          const message = "Updating worksheet status failed";
          handleSnackbarMessageShow(json.error || message);
        }
      });
  };
  const handleDeleteDialog = (...args) => {
    const message = {
      title: "Are you sure you want to delete?",
      subtitle: "This action cannot be undone",
    };
    const handleNo = () => {
      //Close the dialog box
      ReduxDispatcher(
        updateDialogInfo({
          ...user.dialogInfo,
          open: false,
        })
      );
      // trackCrudGA("DeleteNo");
    };
    const handleYes = () => {
      //Close the dialog box
      ReduxDispatcher(
        updateDialogInfo({
          ...user.dialogInfo,
          open: false,
          message: { title: "", subtitle: "" },
        })
      );
      handleDeleteWorksheet.apply(null, args);
      // trackCrudGA("DeleteYes");
    };
    ReduxDispatcher(
      updateDialogInfo({
        ...user.dialogInfo,
        open: true,
        message,
        handleYes,
        handleNo,
      })
    );
  };
  const handleDeleteWorksheet = (...args) => {
    const [workbook, worksheet, variant = "mainPage"] = args;
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "Workspace",
      action: "DeleteWorkspace",
      label: "Delete",
    });

    ReduxDispatcher(updateUserScreen("isDashboardLoading", true));
    const fetchProps = {
      payload: {
        email: user?.reqMetadata?.email,
        workbookId: workbook._id,
        worksheetId: worksheet.sheetId,
        orgViewReq: {
          organization: user?.reqMetadata?.organization,
          view: user?.reqMetadata?.view,
        },
      },
    };

    const deleteChartPromise = deleteWorksheet(fetchProps);
    deleteChartPromise
      .then((responseData) => {
        if (variant === "mainPage") {
          // ! THIS SHOULD BE DONE IN THE APPSERVER in the deleteWorksheet API call
          // 1. Delete the workspace in mongo
          // 2. Get the list of remaining workspaces
          // 3. Set the first one as active

          // ! HANDLING THIS IN THE UI RIGHT NOW
          // 1. Trigger updateWorksheetStatus to update active worksheet in mongo
          const remainingWorksheetsList = workbook.worksheetList.filter(
            (row) => row.sheetId !== worksheet.sheetId
          );
          const firstWorksheet = remainingWorksheetsList[0]; // to make the first one active
          const modifiedWorkbook = {
            ...workbook,
            worksheetList: remainingWorksheetsList,
          };
          const payload = wrapperUpdateWorksheetStatus({
            workbook: modifiedWorkbook,
            worksheet: firstWorksheet,
          });
          const fetchProps = { payload };
          const updateWorksheetStatusPromise =
            updateWorksheetStatus(fetchProps);
          updateWorksheetStatusPromise
            .then((responseData) => {
              // 1. Revert setIsAnyworkbookInRedux to unmound AnalyzeDashboard

              // setIsAnyworkbookInRedux(false);

              // 2. Set new active workspace in redux

              // Set new active workspace in redux
              const activeWorkspacePayload = {
                workbook: modifiedWorkbook,
                worksheet: firstWorksheet,
              };
              const actionValue = {
                activeWorkspace: {
                  wsCategory: "saved",
                  crudType: "update",
                  payload: activeWorkspacePayload,
                },
                isDashboardLoading: false,
              };
              var action = updateUserScreen(null, actionValue);
              ReduxDispatcher(action);

              // 3. Reload Worksheet to trigger useEffect

              // setReloadWorksheet(Date.now());

              // 3. Reload Worksheet to trigger useEffect

              // setReloadWorkbooks(Date.now());
            })
            .catch((json) => {
              if (json.error !== config.hardCoded.queryCancelled) {
                console.error("UI ERROR - API FAILED");
                console.groupCollapsed("DETAILS");
                console.log("JSON -> ", json);
                console.log("ERROR -> ", json.error);
                console.log("updateWorksheetStatus API failed");
                console.groupEnd();

                // ! If the API fails, there old active workspace will be deleted and there will be no new one that will be active
                // ! Hence, such logics should be done in the App Server
                // setIsAnyworkbookInRedux to false so that the component unmounts
                // setIsAnyworkbookInRedux(false);

                // Update User Screen to initial workspace category so that getAllWorkbooks is called
                const message = "Updating worksheet status failed";
                let snackbarPayload = {
                  ...user.screen.snackbar,
                  open: true,
                  message: json.error || message,
                };
                var actionPayload = {
                  snackbar: snackbarPayload,
                  activeWorkspace: initialActiveWorkspace, // This will also reload the workbook data so that it has the correct active worksheet (AnalyzeDashboard.js - useEffect)
                  isDashboardLoading: false,
                };
                var action = updateUserScreen(null, actionPayload);
                ReduxDispatcher(action);
              }
            });
        } else if (variant === "sidenav") {
          let snackbarPayload = {
            ...user.screen.snackbar,
            open: true,
            message: "Worksheet deleted successfully!",
          };
          var actionPayload = {
            snackbar: snackbarPayload,
            isDashboardLoading: false,
          };
          // Update User Screen
          var action = updateUserScreen(null, actionPayload);
          ReduxDispatcher(action);

          // setReloadWorkbooks(Date.now());
        }
      })
      .catch((json) => {
        console.error("UI ERROR - API FAILED");
        console.groupCollapsed("DETAILS");
        console.log("Error JSON -> ", json);
        console.groupEnd();

        var snackbarPayload = {
          ...user.screen.snackbar,
          open: true,
          message: json.error || "Deleting workspace failed",
        };
        var actionPayload = {
          snackbar: snackbarPayload,
          isDashboardLoading: false,
        };
        // Update User Screen
        var action = updateUserScreen(null, actionPayload);
        ReduxDispatcher(action);
      });
  };

  const handleShare = (workbook, worksheet) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "Share",
      action: "ShareURLOpenInSidenav",
      label: "OpenShare",
    });

    const workbookId = user.screen.activeWorkspace.payload.workbook?._id;
    const backendWs = wrapperWs({ user, allData, wsForm, workbookId });
    const payload = {
      ...worksheet.worksheetObject,
      orgViewReq: backendWs.orgViewReq,
    };
    const actionPayload = {
      open: true,
      children: (
        <AnalyzeShareDialog
          user={user}
          ReduxDispatcher={ReduxDispatcher}
          payload={payload}
          type="worksheet"
        />
      ),
    };
    const action = updateUserScreen("sigviewDialog", actionPayload);
    ReduxDispatcher(action);
  };
  const handleWorkspaceNameChangeDialog = (
    worksheetName,
    worksheetId,
    workbookId,
    setReloadWorkbooks
  ) => {
    // trackCrudGA("Clone");
    const initialName = worksheetName;
    const payload = {
      open: true,
      children: (
        <WorkspaceCreateHelpers
          ReduxDispatcher={ReduxDispatcher}
          initialName={initialName}
          user={user}
          worksheetId={worksheetId}
          workbookId={workbookId}
          allData={allData}
          setReloadWorkbooks={setReloadWorkbooks}
        />
      ),
    };
    const action = updateUserScreen("sigviewDialog", payload);
    ReduxDispatcher(action);
  };
  const allWorksheets = useMemo(() => {
    return (
      workbooks?.result?.workbookList?.flatMap((workbook) =>
        (workbook.worksheetList || []).map((worksheet) => ({
          ...worksheet,
          workbook, // keep reference to parent workbook
        }))
      ) || []
    );
  }, [workbooks]);
  const filteredData = useMemo(() => {
    if (!searchQuery.trim()) return allWorksheets;

    const lower = searchQuery.toLowerCase();
    return allWorksheets.filter((item) =>
      item.sheetName?.toLowerCase().includes(lower)
    );
  }, [searchQuery, allWorksheets]);

  return (
    <>
      {filteredData?.length === 0 ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <img
            src={NoSavedReport}
            alt="No records found"
            style={{
              width: "300px",
              height: "auto",
              marginBottom: "12px",
              marginTop: "120px",
            }}
          />
          <p style={{ color: "#6c757d", fontSize: "16px", margin: 0 }}>
            No Worksheet found
          </p>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {filteredData?.map((worksheet) => {
            const workbook = worksheet.workbook;
            const updatedOn = worksheet?.worksheetObject?.updatedOn;
            const formattedTime = (() => {
              if (!updatedOn) return "—";

              const updatedDate = new Date(parseInt(updatedOn, 10));
              const now = new Date();
              const diffInHours = (now - updatedDate) / (1000 * 60 * 60);

              if (diffInHours < 24) {
                return formatDistanceToNow(updatedDate, { addSuffix: true });
              } else {
                return format(updatedDate, "dd/MM/yyyy");
              }
            })();

            return (
              <Grid item xs={12} sm={6} md={3} key={worksheet.sheetId}>
                <Card
                  className="workspaceOpenInNewClicked-GA"
                  onClick={() => handleWorkspaceOpen(workbook, worksheet)}
                  sx={{
                    p: 0,
                    borderRadius: "6px",
                    overflow: "hidden",
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
                    cursor: "pointer",
                    transition: "0.2s",
                    "&:hover": {
                      boxShadow: "0px 4px 16px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Box px={2} py={1.5} sx={{ backgroundColor: "#fff" }}>
                    <SigviewTypography
                      variant="pMedium"
                      style={{ color: "#46596A" }}
                    >
                      {formattedTime}
                    </SigviewTypography>
                  </Box>

                  <Box px={2} py={1.5} sx={{ backgroundColor: "#F8F9FD" }}>
                    <SigviewTypography
                      variant="pLarge"
                      style={{
                        color: "#2E3C5D",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        maxWidth: "100%",
                      }}
                    >
                      {worksheet.sheetName}{" "}
                      {worksheet.isActive ? "(active)" : ""}
                    </SigviewTypography>

                    <Box
                      display="flex"
                      justifyContent="flex-start"
                      gap={2}
                      mt={1}
                      alignItems="center"
                    >
                      <SigviewTooltip title="Rename">
                        <Box
                          className="workspaceRenameClicked-GA"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleWorkspaceNameChangeDialog(
                              worksheet.sheetName,
                              worksheet.sheetId,
                              workbook._id,
                              setReloadWorkbooks
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={renameIcon} alt="Rename" />
                        </Box>
                      </SigviewTooltip>
                      <SigviewTooltip title="Delete">
                        <Box
                          className="workspaceDeletdClicked-GA"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteDialog(workbook, worksheet, "mainPage");
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={deleteIcon} alt="Delete" />
                        </Box>
                      </SigviewTooltip>
                      <SigviewTooltip title="Share">
                        <Box
                          onClick={(e) => {
                            e.stopPropagation();
                            handleShare(workbook, worksheet);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={shareIcon} alt="Share" />
                        </Box>
                      </SigviewTooltip>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  user: state.user,
  allData: state.data,
  standaloneWs: state.standaloneWs,
  globalFilters: state.globalFilters,
});

export default connect(mapStateToProps)(WorkspaceGrid);
